import { refreshToken } from '../../../utils/refreshToken'

interface RetrieveDataProps {
  endpoint: string
  pageSize: number
  offSet: number
  sortBy?: string
  selectedLocationId?: string
  locationId?: string
  orderObjectId?: string
  weekName?: string
  generalFilter?: string
  columnFilters?: object
  additionalData?: boolean
  getRole?: boolean
  getPermissions?: boolean
}

const abortControllers = new Map<string, AbortController>()

async function retrieveData(
  setTableData: Function,
  {
    endpoint,
    offSet,
    pageSize,
    sortBy,
    generalFilter,
    columnFilters,
    selectedLocationId,
    orderObjectId,
    weekName,
    locationId,
    additionalData,
    getRole,
    getPermissions,
  }: RetrieveDataProps,
) {
  if (abortControllers.has(endpoint)) {
    abortControllers.get(endpoint)?.abort()
  }
  const abortController = new AbortController()
  abortControllers.set(endpoint, abortController)

  setTableData((prevState: object) => ({
    ...prevState,
    isLoading: true,
    data: [],
  }))
  const idToken = await refreshToken()

  let url =
    endpoint +
    new URLSearchParams({
      pageSize: pageSize.toString(),
      offSet: offSet.toString(),
    })
  if (sortBy) {
    url += `&sortBy=${sortBy}`
  }
  if (generalFilter) {
    url += `&searchValue=${generalFilter}`
  }
  if (orderObjectId) {
    url += `&orderObjectId=${orderObjectId}`
  }
  if (selectedLocationId) {
    url += `&selectedLocationId=${selectedLocationId}`
  }
  if (locationId) {
    url += `&locationId=${locationId}`
  }
  if (weekName) {
    url += `&weekName=${weekName}`
  }
  if (columnFilters) {
    url += `&columnFilters=${JSON.stringify(columnFilters)}`
  }
  if (getRole) {
    url += `&getRole=${getRole}`
  }
  if (getPermissions) {
    url += `&getPermissions=${getPermissions}`
  }
  fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: idToken ? `Bearer ${idToken}` : '',
    },
    signal: abortController.signal, // Attach the signal to the fetch request
  })
    .then((res) => res.json())
    .then((data) => {
      let transformedData = data.items
      let count = data.count
      if (additionalData) {
        //This is specifically for the invoice table in WO Details
        setTableData((prevState: object) => ({
          ...prevState,
          isLoading: false,
          data: transformedData,
          allInvoices: data['All Invoices'],
        }))
      } else {
        setTableData((prevState: object) => ({
          ...prevState,
          isLoading: false,
          data: transformedData,
          count: count,
        }))
      }
    })
    .catch((err) => {
      console.error(err)
      setTableData((prevState: object) => ({
        ...prevState,
        isLoading: false,
        data: [],
      }))
    })
}

export default retrieveData
